// extracted by mini-css-extract-plugin
export default {"buttonOnly":"LandscapeProjectsTemplate_buttonOnly__lg56X","tableCell":"LandscapeProjectsTemplate_tableCell__H3vbA","tableRow":"LandscapeProjectsTemplate_tableRow__FdBeb"};